import { Toolbar } from 'common/ProseInput/components/Toolbar'
import { useCollabItemContext } from 'components/CollabItem/CollabItem'
import { CTAProps, CommentForm } from 'components/CommentForm/CommentForm'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useRootStore } from 'stores/RootStore'
import Styles from './ItemEditForm.module.scss'

import { ItemEditFormProps } from './Types'
import { Button } from 'blaze-ui/Button'
import { noop } from 'lodash'

const PrimaryCTA = (props: CTAProps) => {
  return (
    <Button size="sm" {...props}>
      Update
    </Button>
  )
}

const ItemEditForm = observer(({ comment }: ItemEditFormProps) => {
  const rootStore = useRootStore()
  const { setEditing } = useCollabItemContext()
  const [newValue, setNewValue] = useState(comment.html_comment)
  const [newMentionedUserIds, setNewMentionedUserIds] = useState<number[]>([])

  const handleSubmit = async () => {
    rootStore.comments.update(comment.id, { comment: newValue }, newMentionedUserIds, true)
    setEditing(undefined)
  }

  const handleChange = (value: string, mentionedUserIds: number[]) => {
    setNewValue(value)
    setNewMentionedUserIds(mentionedUserIds)
  }

  useEffect(() => {
    if (comment.html_comment) {
      setNewValue(comment.html_comment)
    }
  }, [comment.html_comment])

  return (
    <CommentForm
      autoFocus
      value={newValue}
      onChange={handleChange}
      onSubmit={handleSubmit}
      className={Styles.form}
      onCancel={() => setEditing(undefined)}
      showAvatar={false}
      primaryCta={<PrimaryCTA onPress={noop} isDisabled={false} />}
      inputContainerClassName={Styles.inputContainer}
      isHtmlComment
      footer={
        <Toolbar.Root>
          <Toolbar.Bold />
          <Toolbar.BulletList />
          <Toolbar.Mention />
        </Toolbar.Root>
      }
    />
  )
})

export { ItemEditForm }
